import { injectedStore } from '../../ConfigureStore';

export default function getAPIBaseURL(): string {
  return injectedStore.getState().config.apiBaseURL;
}
